import { render } from "./School.vue?vue&type=template&id=169ae2ac&scoped=true"
import script from "./School.vue?vue&type=script&lang=js"
export * from "./School.vue?vue&type=script&lang=js"

import "./School.vue?vue&type=style&index=0&id=169ae2ac&lang=scss&scoped=true"

import exportComponent from "D:\\code\\newspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169ae2ac"]])

export default __exports__